import React from "react";
import { ReactComponent as FbIcon } from "../../inlineSvgs/fb.svg";
import FacebookLogin from "@greatsumini/react-facebook-login";
import { facebookAuth } from "../../api";
import { useDispatch } from "react-redux";
import { saveToken } from "../../store/slice/userSlice";
import { useNavigate, useLocation } from "react-router-dom";
import { showNotification } from "../../config";

const facebookAppId = process.env.REACT_APP_FACEBOOK_APP_ID;

const FacebookLogIn = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <FacebookLogin
      appId={facebookAppId}
      scope="public_profile,email"
      onSuccess={(response) => {
        const token = response.accessToken;
        let from = location.state?.from;
        from = typeof from === "string" ? from : undefined;
        facebookAuth(token)
          .then((res) => {
            if (res.data.access_token) {
              dispatch(saveToken(res.data.access_token));
            }
          })
          .catch((e) => {
            if (e?.response?.unfilledData.includes("email")) {
            //   localStorage.setItem("fbToken", token);
              navigate("/login", { state: { from } });
            }
          });
      }}
      onFail={(error) => {
        console.log('Login Failed!', error);
        showNotification('Login Failed!');
      }}
      render={({ onClick }) => (
        <button type="button" onClick={onClick} className="beauty-btn border with-icon">
          <FbIcon /> <span>Login using Facebook</span>
        </button>
      )}
    />
  );
};

export default FacebookLogIn;
